import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'consts/query/queryKey'

import { getChannels } from './requests'

export const useChannelsQuery = () => {
  return useQuery({
    queryKey: [QueryKey.GetChannels],
    queryFn: () => getChannels(),
  })
}
